import { createApiClient } from './client.js';
import { createAuthApi } from './auth.js';
import { createAdminApi, createPortalApi, createPublicApi } from './resources.js';

export { createApiClient, buildQuery, readCookie } from './client.js';
export { createAuthApi } from './auth.js';
export { createSseParser, readSseResponse } from './sse.js';
export { ProblemError, isProblemError, getErrorMessage, hasProblemType, RESEND_PROBLEM_TYPES, PROBLEM_TYPE_TWO_FACTOR_REQUIRED } from './errors.js';
export { keys, meQueryOptions } from './keys.js';
export { createAdminApi, createPortalApi, createPublicApi, toListQuery, toFormData } from './resources.js';
export { adminQueries, portalQueries, publicQueries } from './queries.js';

/**
 * Convenience: client + resource APIs in one object.
 * @param {import('./client.js').ApiClientOptions} options
 */
export function createBlimoApi(options) {
  const client = createApiClient(options);
  return { client, auth: createAuthApi(client), admin: createAdminApi(client), portal: createPortalApi(client), public: createPublicApi(client) };
}

/** @typedef {ReturnType<typeof createBlimoApi>} BlimoApi */
